'use client';

import { FC, ReactNode } from 'react';

import { useInitializeTranslations } from '@telialt/common-cms/src/useTranslations';

import { CategorySkeleton } from '../CategorySkeleton/CategorySkeleton';

export const TranslationsInit: FC<{ children?: ReactNode }> = ({ children }) => {
    const { t } = useInitializeTranslations();

    if (!t) {
        return <CategorySkeleton />;
    }

    return <>{children}</>;
};
